// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"CategoryCreateEditForm_MainContainer__1RPY1","Heading":"CategoryCreateEditForm_Heading__3ACbP"};